import { useEffect, useState } from "react";
import { Box, FormLabel, TextField, Typography } from "@mui/material";
import InputsYorN from "../ProfilesComp/InputsYorN";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const StepInsurance = ({ updateInsuranceTranspor }) => {
    const storedData = useSelector(state => state.profiles.Insurance);
    const { t } = useTranslation();
    const [insurance, setInsurance] = useState({
        Medicare: "",
        MedicaID: "",
        VABenefits: "",
        COBRA: "",
        coverage: "",
        ACA: "",
        Insurance: "",
        InsuranceCompany: "",
    });

    useEffect(() => {
        setInsurance  ((prevData) => ({
            ...prevData,
            ...storedData
        }));
    }, [storedData]);

    const handleChange = async(field, value) => {
        setInsurance((prevData) => ({
            ...prevData,
            [field]: value
        }));
    };

    const handleNextStep = async (field, value) => {
        await handleChange(field, value); // 🔹 Espera que termine antes de seguir
        updateInsuranceTranspor({ Insurance: insurance });
    };

    return (
        <>
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                {t("Profiles.Insurance.Insurance")}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <FormLabel component="legend">{t("Profiles.Insurance.InsuranceDoyouhavehealth")}</FormLabel>
            </Box>
            <Box >
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    <Box sx={{ flex: "1 1 20%" }}>
                        <InputsYorN translationKey="Profiles.Insurance.Medicare" value={insurance.Medicare} onChange={(val) => handleNextStep("Medicare", val)} />
                    </Box>
                    <Box sx={{ flex: "1 1 20%" }}>
                        <InputsYorN translationKey="Profiles.Insurance.MedicaID" value={insurance.MedicaID} onChange={(val) => handleNextStep("MedicaID", val)} />
                    </Box>

                    <Box sx={{ flex: "1 1 20%" }}>
                        <InputsYorN translationKey="Profiles.Insurance.VABenefits" value={insurance.VABenefits} onChange={(val) => handleNextStep("VABenefits", val)} />
                    </Box>
                    <Box sx={{ flex: "1 1 20%" }}>
                        <InputsYorN translationKey="Profiles.Insurance.COBRA" value={insurance.COBRA} onChange={(val) => handleNextStep("COBRA", val)} />
                    </Box>

                    <Box sx={{ flex: "1 1 20%" }}>
                        <InputsYorN translationKey="Profiles.Insurance.coverage" value={insurance.coverage} onChange={(val) => handleNextStep("coverage", val)} />
                    </Box>
                    <Box sx={{ flex: "1 1 20%" }}>
                        <InputsYorN translationKey="Profiles.Insurance.ACA/Private" value={insurance.ACA} onChange={(val) => handleNextStep("ACA", val)} />
                    </Box>

                    <Box sx={{ flex: "1 1 20%" }}>
                        <InputsYorN translationKey="Profiles.Insurance.Insurance" value={insurance.Insurance} onChange={(val) => handleNextStep("Insurance", val)} />
                    </Box>
                </Box>
            </Box>
            {insurance.Insurance === "yes" && (
                <TextField 
                    fullWidth 
                    label={t("Profiles.Insurance.NameofInsCo")} 
                    margin="normal" 
                    value={insurance.InsuranceCompany} 
                    onChange={(e) => handleNextStep("InsuranceCompany", e.target.value)} 
                />
            )}
        </>
    );
};

export default StepInsurance;
